import { PRODUCT_CATEGORIES, PRODUCT_SKU_PREFIX, PRODUCT_TYPES } from "@sdk-point/talisis";

export const getAddonFromCart = (cartItems) => {
    return cartItems.find(item =>
        item.product_category_id === PRODUCT_CATEGORIES.ADDON &&
        item.product_type_id === PRODUCT_TYPES.LICENCIA &&
        item.product_sku.includes(PRODUCT_SKU_PREFIX.HARMON_HALL)
    );
};